import React, { useState } from 'react'
import { __ } from '@wordpress/i18n'
export const MeetingDetails = (props) => {
  const { meeting, acf_options } = props
  const [showDesc, setShowDesc] = useState(false);
  return (
    <div className={'meeting-details'}>
      <h4>{meeting.startDate} r.</h4>
      <h2>
        {meeting.title}
      </h2>
      <p dangerouslySetInnerHTML={{__html: meeting.shortDesc}}></p>
      {meeting.desc && !showDesc ? (<a onClick={() => {setShowDesc(true)}}>{__('Rozwiń', 'strefamanagera')}</a>) : null}
      {showDesc ? (<p dangerouslySetInnerHTML={{__html: meeting.desc}}></p>) : null}
      {showDesc ? (<a onClick={() => {setShowDesc(false)}}>{__('Zwiń', 'strefamanagera')}</a>) : null}
    </div>
  )
}